import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import ProtectedRoute from 'components/ProtectedRoute';
import DashboardLayout from 'layout/Dashboard';

// render - dashboard pages
const DefaultPages = Loadable(lazy(() => import('views/navigation/dashboard/Default')));
const WorkspacesPage = Loadable(lazy(() => import('views/navigation/workspaces/Workspaces')));

// ==============================|| NAVIGATION ROUTING ||============================== //

const NavigationRoutes = {
  path: '/',
  children: [
    {
      path: '/dashboard',
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '/dashboard',
          element: <DefaultPages />
        },
        {
          path: 'workspaces',
          element: <WorkspacesPage />
        }
      ]
    }
  ]
};

export default NavigationRoutes;
